const freeLanguages = [
  { title: "Afrikaans (South Africa)", key: "af" },
  // { title: "Albanian (Albania)", key: "sq" },
  { title: "Arabic (United Arab Emirates)", key: "ar" },
  // { title: "Armenian (Armenia)", key: "hy" },
  { title: "Bengali (India)", key: "bn" },
  { title: "Bulgarian (Bulgaria)", key: "bg" },
  { title: "Catalan (Spain)", key: "ca" },
  { title: "Mandarin (simplified)", key: "zh-CN" },
  { title: "Mandarin (traditional)", key: "zh-TW" },
  // { title: "Croatian (Croatia)", key: "hr" },
  { title: "Czech (Czech Republic)", key: "cs" },
  { title: "Danish (Denmark)", key: "da" },
  { title: "Dutch (Netherlands)", key: "nl" },
  { title: "English (USA)", key: "en" },
  // { title: "Esperanto", key: "eo" },
  // { title: "Filipino (Philippines)", key: "fil" },
  { title: "Finnish (Finland)", key: "fi" },
  { title: "French (France)", key: "fr" },
  { title: "German (Germany)", key: "de" },
  { title: "Greek (Greece)", key: "el" },
  { title: "Gujarati (India)", key: "gu" },
  { title: "Haitian Creole", key: "ht" },
  { title: "Hindi (India)", key: "hi" },
  { title: "Hungarian (Hungary)", key: "hu" },
  { title: "Icelandic (Iceland)", key: "is" },
  { title: "Indonesian (Indonesia)", key: "id" },
  { title: "Italian (Italy)", key: "it" },
  { title: "Japanese (Japan)", key: "ja" },
  { title: "Kannada (India)", key: "kn" },
  { title: "Korean (South Korea)", key: "ko" },
  { title: "Latvian (Latvia)", key: "lv" },
  { title: "Malayalam (India)", key: "ml" },
  // { title: "Mandarin Chinese", key: "cmn" },
  // { title: "Norwegian (Norway)", key: "nb" },
  { title: "Polish (Poland)", key: "pl" },
  { title: "Portuguese (Portugal)", key: "pt" },
  { title: "Romanian (Romania)", key: "ro" },
  { title: "Russian (Russia)", key: "ru" },
  { title: "Serbian (Cyrillic)", key: "sr" },
  { title: "Slovak (Slovakia)", key: "sk" },
  { title: "Spanish (Mexico)", key: "es" },
  { title: "Swedish (Sweden)", key: "sv" },
  { title: "Tamil (India)", key: "ta" },
  { title: "Telugu (India)", key: "te" },
  { title: "Thai (Thailand)", key: "th" },
  { title: "Turkish (Turkey)", key: "tr" },
  { title: "Ukrainian (Ukraine)", key: "uk" },
  { title: "Vietnamese (Vietnam)", key: "vi" },
];

export default freeLanguages;
